import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAfiliados } from "../../acciones/index.js";
import "./famiCartel.css";
import { NavBar } from "../../componentes/navbar/index";
import { PerfilFami } from "../../componentes/perfilFami/perfilFamili.jsx";
import { ImgCabecera } from '../../componentes/imgCabecera/imgCabe';
import { useHistory } from "react-router-dom";
import AdSenseComponent from '../../componentes/adSense/adSenseComponent';


export const FamiCartel = () => {

    const dispatch = useDispatch();
    const afiliados = useSelector((state) => state.afiliados); // Obtiene afiliados del estado global
    const history = useHistory(); // Para redirigir

    useEffect(() => {
        dispatch(getAfiliados()); // Despacha la acción para obtener afiliados
    }, [dispatch]);

    const handleRedirect = (userId) => {
        console.log("Redirigiendo con ID:", userId); // Verifica el ID antes de redirigir
        history.push(`/FamiliaCartel/perfil/${userId}`);
    };

    return (
        <div>
            <ImgCabecera />
            <NavBar />
            <div style={{ margin: '1rem 0' }}>
                <AdSenseComponent />
            </div>
            <h1 className="tituloFamiliaCartel">FAMILIA DE CARTEL</h1>
            <input placeholder="Buscar Integrante" className="inputFamiCartel" />
            <br></br>
            <br></br>
            <br></br>
            <div className="espacioPerfilesFami">

                {afiliados.length > 0 ? (
                    afiliados.map((afiliado) => (
                        <PerfilFami
                            key={afiliado.user_id}
                            nombre={afiliado.nombre_usuario}
                            imagen={afiliado.imagen_perfil} // Asegúrate de que esto sea un string en Base64
                            onClick={() => handleRedirect(afiliado.user_id)}
                        />
                    ))
                ) : (
                    <p>No hay afiliados disponibles</p>
                )}
            </div>
        </div>
    )
}